<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="http://www.100ec.cn/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E7%94%9F%E6%B4%BB&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社法律消保台</span>
        <a href="http://www.100ec.cn/rulelaw/#/broadcast" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://www.100ec.cn/rulelaw/#/broadcast" target="_blank">
          <img
            style="width: 100%"
            src="/Public/home/images/zyttk/flxb550.jpg"
          />
        </a>
      </div>
    </div> -->

    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>
      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>
    <!-- <div class="right-box">
      <div class="right-title">
        <span>合作伙伴</span>
      </div>
      <ul class="partner-list">
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/dd.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/xc.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/qnr.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/tcly.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/yl.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/mfw.jpg"
            />
          </a>
        </li>
        <li>
          <a>
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/cccx.png"
            />
          </a>
        </li>
      </ul>
    </div> -->
    <div style="width: 365px">
      <img style="width: 100%" src="/Public/tuku/6a0ad7a00b889.jpg" />
    </div>
    <div style="width: 365px; margin-top: 20px">
      <a href="/zt/wycgjk/" target="_blank">
        <img
          style="width: 100%"
          src="/Public/Upload/image/20260625/1782356417271476.gif"
        />
      </a>
    </div>
    <div style="width: 365px; margin-top: 20px">
      <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/ydcxt.jpg"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "数字生活",
        tabs: ["交通出行", "在线旅游"],
      },
      year: "",
      time: "",
      platform: [],
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=54" +
          // this.$store.state.type +
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform: function (index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>
<style>
.partner-list li {
  padding: 10px;
  flex: 0 0 20%;
}
.partner-list img {
  width: 106px;
  border-radius: 2px;
  opacity: 1;
  transition: all 0.3s ease;
}
</style>